import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00080InstallationAlarmRXComponent } from './P00080/Installation/p00080-installation-alarm-rx/p00080-installation-alarm-rx.component';
import { P00080InstallationAlarmPHComponent } from './P00080/Installation/p00080-installation-alarm-ph/p00080-installation-alarm-ph.component';
import { P00080InstallationFinish } from './P00080/Installation/P00080InstallationFinish';
import { P00080InstallationReset } from './P00080/Installation/P00080InstallationReset';
import { P00080CardAltimeoControleComponent } from './P00080/Altimeo/cards/p00080-card-altimeo-controle/p00080-card-altimeo-controle.component';
import { P00080CardAltimeoStatutComponent } from './P00080/Altimeo/cards/p00080-card-altimeo-statut/p00080-card-altimeo-statut.component';
import { P00080Alarm } from './P00080/Alarm/P00080Alarm';
import { P00080AltimeoMiseEnOeuvreRxComponent } from './P00080/Altimeo/miseenoeuvre/p00080-altimeo-mise-en-oeuvre-rx/p00080-altimeo-mise-en-oeuvre-rx.component';
import { P00080AltimeoMiseEnOeuvrePhComponent } from './P00080/Altimeo/miseenoeuvre/p00080-altimeo-mise-en-oeuvre-ph/p00080-altimeo-mise-en-oeuvre-ph.component';

import { P00080AltimeoMiseEnOeuvreInit } from './P00080/Altimeo/miseenoeuvre/P00080AltimeoMiseEnOeuvreInit';
import { P00080AltimeoControleComponent } from './P00080/Altimeo/cps/p00080-altimeo-controle/p00080-altimeo-controle.component';
import { P00080AltimeoParametersComponent } from './P00080/Altimeo/cps/p00080-altimeo-parameters/p00080-altimeo-parameters.component';
import { P00080AltimeoStatutComponent } from './P00080/Altimeo/cps/p00080-altimeo-statut/p00080-altimeo-statut.component';
import { P00039 } from './P00039';
import { P0003600 } from './P0003600';
import { P0004700 } from './P0004700';
import { P00046 } from './P00046';
import { P0003601 } from './P0003601';
import { P00058 } from './P00058';
import { P0006600 } from './P0006600';
import { P00032 } from './P00032';
import { P00080AltimeoMiseEnOeuvreProtectionDebitComponent } from './P00080/Altimeo/miseenoeuvre/p00080-altimeo-mise-en-oeuvre-protection-debit/p00080-altimeo-mise-en-oeuvre-protection-debit.component';
import { P00080InstallationPositionComponent } from './P00080/Installation/p00080-installation-position/p00080-installation-position.component';

export class P00080Data {
  alSMesurePh: number = 0;
  alSMesureRx: number = 0;

  alSEtatPhControlAlarmsRunning: number = 0;
  alSEtatPhSensorBeingStarted: number = 0;
  alSEtatPhTemporaryBreak: number = 0;
  alSEtatPhCirculationContactFlowmeter: number = 0;
  alSEtatPhNecessaryMaintenance: number = 0;
  alSEtatPhDosingInProgress: number = 0;
  alSEtatPhAlarmInProgress: number = 0;
  alSEtatPhControlAlarmPausedTimer: number = 0;
  alSEtatPhOffScaleDisconnectedSensors: number = 0;
  alSEtatPhSensorsOutsideMeasurementRange: number = 0;
  alSEtatPhUnstableSensorValue: number = 0;
  alSEtatPhLowAlarmThresholdCrossed: number = 0;
  alSEtatPhHighAlarmThresholdCrossed: number = 0;
  alSEtatPhNotUsed: number = 0;
  alSEtatPhBottomOfTank: number = 0;
  alSEtatPhMaxDosingTime: number = 0;
  alSEtatPhUseOfTimer: number = 0;
  alSEtatPhRemoteControlInProgress: number = 0;
  alSEtatPhChannelConfigurationError: number = 0;

  // Etat RX
  alSEtatRxControlAlarmsRunning: number = 0;
  alSEtatRxSensorBeingStarted: number = 0;
  alSEtatRxTemporaryBreak: number = 0;
  alSEtatRxCirculationContactFlowmeter: number = 0;
  alSEtatRxNecessaryMaintenance: number = 0;
  alSEtatRxDosingInProgress: number = 0;
  alSEtatRxAlarmInProgress: number = 0;
  alSEtatRxControlAlarmPausedTimer: number = 0;
  alSEtatRxOffScaleDisconnectedSensors: number = 0;
  alSEtatRxSensorsOutsideMeasurementRange: number = 0;
  alSEtatRxUnstableSensorValue: number = 0;
  alSEtatRxLowAlarmThresholdCrossed: number = 0;
  alSEtatRxHighAlarmThresholdCrossed: number = 0;
  alSEtatRxNotUsed: number = 0;
  alSEtatRxBottomOfTank: number = 0;
  alSEtatRxMaxDosingTime: number = 0;
  alSEtatRxUseOfTimer: number = 0;
  alSEtatRxRemoteControlInProgress: number = 0;
  alSEtatRxChannelConfigurationError: number = 0;

  alSMiseRouteFiltrationPh: number = 0;
  alSMiseRouteFiltrationRx: number = 0;
  alSEtatBouton: number = 0;
  alSSecuriteDeconnexionProduit: number = 0;
  alSAlarm: number = 0;
  alSSwitchK2Debit: number = 0;

  alSCompteurBouton: number = 0;
  alSCompteurResetUsine: number = 0;

  alCEtatProduit: number = 0;
  alCComfirmationOTA: number = 0;
  alCResetUsine: number = 0;
  alCConsignePh: number = 0;
  alCConsigneRX: number = 0;

  alIConsigneAlarmHautePH: number = 0;
  alIConsigneAlarmBassePH: number = 0;
  alIConsigneAlarmHauteRX: number = 0;
  alIConsigneAlarmBasseRX: number = 0;

  alIConfigurationProduit: number = 0;
  alIActivationAutoMaintienPH: number = 0;
  alIActivationAutoMaintienRX: number = 0;

  alISourceReferenceDebit: number = 0;
  alSEtatProduit: number = 0;
  alSMesureDebit: number = 0;
  alSDisponibiliteDebit: number = 0;
  alSDureeDebitMaintenu: number = 0;
}

export class P00080 extends IProduct {
  override deviceTableIndex: number = 30;

  override modelIdentifier?: string = 'P00080';

  override dataIdentifier?: string = 'P00080';

  override manufacturerName?: string = 'ACWA';

  data: P00080Data = new P00080Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00080/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00080/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00080/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00080;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00080?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00080.tuto.installation.help.title',
      helpSlides: [
        'P00080.tuto.installation.help.1',
        'P00080.tuto.installation.help.2',
        'P00080.tuto.installation.help.3',
        'P00080.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00080/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00080/installation-1_dark.png',
          },
          text: 'P00080.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00080/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00080/installation-2_dark.png',
          },
          text: 'P00080.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00080/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00080/installation-1_dark.png',
          },
          text: 'P00080.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00080/update-2.png',
            dark: '/assets/ecosystem/images/products/P00080/update-2_dark.png',
          },
          text: 'P00080.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P00080InstallationAlarmRXComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P00080InstallationAlarmPHComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P00080InstallationPositionComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P00080InstallationFinish,
        reset: P00080InstallationReset,
      },
      controlCards: [
        { component: P00080CardAltimeoControleComponent, weight: 19 },
      ],

      statusCards: [{ component: P00080CardAltimeoStatutComponent, weight: 2 }],

      alarms: {
        weight: 22,
        component: P00080Alarm,
      },

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.TREATMENTCLPH];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.INJECTION_CLPH ||
      functionnality == EventProductFunctionnalityEnum.TREATMENTCLPH
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P00080AltimeoMiseEnOeuvreProtectionDebitComponent,
              condition: (pool: Pool) => {
                const presenceFiltration =
                  new P00039().hasProduct(pool, new P0003600()) > 0 ||
                  new P00039().hasProduct(pool, new P0004700()) > 0 ||
                  new P00039().hasProduct(pool, new P00046()) > 0 ||
                  new P00039().hasProduct(pool, new P0003601()) > 0 ||
                  new P00039().hasProduct(pool, new P00058()) > 0 ||
                  new P00039().hasProduct(pool, new P0006600()) > 0;

                const presenceDebitSense =
                  new P00039().hasProduct(pool, new P00032()) > 0 &&
                  pool.deviceTable.P00032.data.snIInstallationCapteurDebit == 1;

                return presenceFiltration && presenceDebitSense;
              },
            },
            {
              component: P00080AltimeoMiseEnOeuvreRxComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P00080AltimeoMiseEnOeuvrePhComponent,
              condition: () => {
                return true;
              },
            },
          ],
          init: P00080AltimeoMiseEnOeuvreInit,
        },
        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P00080AltimeoControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P00080AltimeoParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00080AltimeoStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00080.historique.mesureRX',
                mode: HistoryGraphModeEnum.DATA,
                property: 'alSMesureRx',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.MVOLT,
                yModeOptions: { min: 0, max: 100000, divided: 100 },
                chartMode: HistoryChartModeEnum.LINEAR,
              },
              {
                title: 'P00080.historique.mesurePH',
                mode: HistoryGraphModeEnum.DATA,
                property: 'alSMesurePh',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.PH_CENTIEME,
                yModeOptions: { min: 0, max: 1000 },
                chartMode: HistoryChartModeEnum.LINEAR,
              },
            ],
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.Altimeo_Control,
      propertyName: 'alCComfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 1;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).alIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
